module.exports = ".row{\r\n    padding-top:20px;\r\n}\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/daily-attendance/daily-attendance-form/daily-attendance-form.component.css
// module id = ./src/app/hrms/Attendance-Leaves/daily-attendance/daily-attendance-form/daily-attendance-form.component.css
// module chunks = main